import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import _ from 'lodash';
import isNumber from 'lodash/isNumber';
import {
  Menu, MenuItem, Switch,
} from '@mui/material';
import {
  Delete, CloudUpload as CloudUploadIcon, Share as ShareIcon, LocalOffer as TagIcon,
} from '@mui/icons-material';
import Dropzone from 'react-dropzone';

import pLimit from 'p-limit';
import AddTagsMenu from '../TagsMenu/component';
import { UiSection } from '../../../enums';
import { ISearchResultsLocaleLookupKeys, LocaleKeyTree } from '../../../localization';
import {
  AssetDetailsDrag,
  AssetDetailsDragContainer,
  ButtonSpacer,
  FilterButtonContainer,
  FilterContainer,
  QueryResultContainer,
  ResultDetailsContainer,
  ResultsActionContainer,
  SocialButton,
  StyledControl,
  TableAndPreviewContainer,
  TableContainer,
  AddTagButton,
  SecurityProfileFilterContainer,
  AdvancedFilterButtonContainer,
} from './styles';

import { IAppState } from '../../../state/reducers';
import { Product } from '../../../state/product';
import { clearJobs, closeJobStatusReview, openJobStatusReview } from '../../../state/jobStatus';
import {
  Separator, SocialPublishOptions, VaultButton,
} from '../../Shared';
import {
  IDispatchProps, IProps, IState, IStateProps,
} from './interfaces';
import SearchTable from '../SearchTable/component';
import {
  IPublishMetadata, IPublishSettings, SettingState, SettingType,
} from '../../../api/vault/publishEndpoints';
import AssetDetails from '../../AssetDetails/index';
import { updateRawAssetDetails } from '../../../state/rawAssetDetails';
import { getAssetFromApi } from '../../AssetDetails/api/assetsLookupsMetatags';
import { publishSelectedAssetsToEndPoints, resetPublishedAssets } from '../../../state/publishAssets';
import { AssetHit } from '../../../api/vault/searchEngine/interfaces';
import {
  queryGamesAction, resetPage, toggleOwnedFilter, toggleNoSecurityProfileFilter, getTeamIconsAction,
  onAdvancedSecurityProfileFiltersChanged,
  selectSelectedSecurityProfileOptions,
  clearAllAdvancedFilters,
} from '../../../state/search';
import { clearAllFilters, updateFilterValues } from '../../../state/filterAssets';
import { toggleShareDialog } from '../../../state/shareDialog';
import { toggleEmailDialog } from '../../../state/shareEmailDialog';
import { toggleDeleteAssets } from '../../../state/deleteAssets';
import { toggleBulkEditAssets } from '../../../state/bulkUpdateAssets';
import { toggleUploadExchangeDialog } from '../../../state/exchange/uploadDialog';
import { Colors, Routes, VAULT_VIDEO_TYPE } from '../../../constants';
import DeleteAssetsDialog from '../DeleteAssetsDialog/component';
import {
  selectIsAssetDeletionPermitted,
  selectIsPublishPermitted,
  selectIsUserExchangeAdmin,
  selectIsUserVaultCustomerAdmin,
  selectIsUserVaultEditor,
  selectIsUserVaultSuperAdmin,
  selectUserOrgIds,
  selectUserOrgsSecurityProfilesIds,
  selectIsUserExchangeVendor,
  selectIsSharePermitted,
  selectIsAssetDownloadPermitted,
  selectIsAssetBulkEditPermitted,
  selectIsAssetBulkTagPermitted,
} from '../../../state/user/userOrgRole';
import { SelectionModel } from '../../../cdk/selection';
import TwitterPublishDialog from './TwitterPublishDialog/component';
import YouTubePublishDialog from './YouTubePublishDialog/component';
import VaultPublishOptions from './VaultPublishOptions/component';
import ShareDialog from './ShareDialog/component';
import ShareEmailDialog from './ShareEmailDialog/component';
import SearchPagination from './SearchPagination/component';
import VaultUploadDialog from './VaultUploadDialog/component';
import UploadExchangeDialog from '../../Exchange/UploadDialog/component';
import { upload } from '../../../utils/upload';
import { downloadAsset } from '../../../utils/downloadAsset';
import BulkEditDialog from './BulkEditDialog/component';
import { resetAssetDetails } from '../../../state/previewAsset';
import { selectUserPublishSettings } from '../../../state/publishEndpoints/selectors';
import { toggleVaultUploadDialog } from '../../../state/vaultUploadDialog';
import { copyAssetsToClipboard } from '../../../utils/copyAssetsToClipbaord';
import { selectOptionsByName, LookupName } from '../../../state/lookups';
import AdvancedFilterPopover from '../../Shared/AdvancedFilterPopover';
import { ISecurityProfileOption, selectSecurityProfileOptions } from '../../../state/securityProfiles';
import SecurityProfileFilter from '../../Shared/SecurityProfileFilter';
import { IPublishAsset, PublishRenditionType } from '../../../api/vault/publishAssets';
import { ActionType, ActionStatus } from '../../../api/vault/assetStatus/interfaces';
import { createAssetStatus } from '../../../api/vault/assetStatus/api';
import { loadedAssetMetadata } from '../../../state/utils/assetDetails';

const DropContainer = styled.div`
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  align-items: left;
  border-width: 2px;
  border-radius: 2px;
  border-color: #ffffff;
  border-style: solid;
  background-color: #ffffff;
  color: #fa0000;
  outline: none;
  transition: border .24s ease-in-out;
`;

class SearchResults extends PureComponent<IProps, IState> {
  private static readonly deleteButtonId = `${UiSection.SearchResults}.Delete`;
  private static readonly bulkDownloadButtonId = `${UiSection.SearchResults}.bulkDownload`;
  private static readonly bulkUpdateButtonId = `${UiSection.SearchResults}.bulkUpdate`;
  private static readonly clearFilterId = `${UiSection.SearchResults}.clearFilter`;
  private static readonly runFilterId = `${UiSection.SearchResults}.runFilter`;
  private static readonly tagButtonId = `${UiSection.SearchResults}.bulkTag`;

  private readonly localeLookupKeys: Readonly<ISearchResultsLocaleLookupKeys> = LocaleKeyTree.searchResults;

  state: Readonly<IState> = {
    selectedAssetIds: [],
    selectedAssets: [],
    assetIdSelection: new SelectionModel<string>(),
    shareAnchorEl: null,
    addTagsAnchorEl: null,
    loadedInitialAsset: false,
  };

  private tableContainerRef: React.RefObject<HTMLDivElement>;
  private tableAndPreviewRef: React.RefObject<HTMLDivElement>;
  private dragContainerRef: React.RefObject<HTMLDivElement>;
  private dragRef: React.RefObject<HTMLDivElement>;

  private isPreviewPanelDragging = false;

  private mouseDownHandler = (e: any) => {
    let change = false;
    if (e.target === this.dragRef.current || e.target === this.dragContainerRef.current) {
      if (!this.isPreviewPanelDragging) change = true;
      this.isPreviewPanelDragging = true;
    } else {
      if (this.isPreviewPanelDragging) change = true;
      this.isPreviewPanelDragging = false;
    }

    if (change) this.forceUpdate();
  };

  private mouseUpHandler = (e: any) => {
    let change = false;
    if (e.target === this.dragRef.current || e.target === this.dragContainerRef.current) {
      if (this.isPreviewPanelDragging) change = true;
      this.isPreviewPanelDragging = false;
    } else {
      if (this.isPreviewPanelDragging) change = true;
      this.isPreviewPanelDragging = false;
    }

    if (change) this.forceUpdate();
  };

  private mouseMoveHandler = (e: any) => {
    if (!this.isPreviewPanelDragging) {
      return;
    }

    const pointerRelativeXPos = e.clientX - this.tableAndPreviewRef.current.offsetLeft - 6;

    if (pointerRelativeXPos > 420) {
      this.tableContainerRef.current.style.width = `${pointerRelativeXPos}px`;
      this.tableContainerRef.current.style.flexGrow = '0';
    }
  };

  private static downloading: number = 0;

  onDrop = async (files: File[]) => {
    const {
      userOrgs, queryGamesActionConnect, systemSettings, isUserVaultSuperAdmin, iptcCategoryOptions,
    } = this.props;
    const limit = pLimit(3);
    const input: any = [];

    files.forEach((item) => {
      input.push(limit(async () => {
        SearchResults.downloading += 1;
        await upload(item, userOrgs[0], VAULT_VIDEO_TYPE.MyVault, systemSettings, {}, {}, isUserVaultSuperAdmin, iptcCategoryOptions);
        SearchResults.downloading -= 1;
      }));
    });

    await Promise.all(input);

    const {
      location: {
        pathname: route,
      },
    } = window;

    if (route === Routes.HOME) {
      queryGamesActionConnect();
    }
  };

  onBeforeUnload = (e: BeforeUnloadEvent) => {
    // Cancel the event as stated by the standard.
    if (SearchResults.downloading > 0) {
      e.preventDefault();
      e.returnValue = true;
    }
  };

  componentDidMount() {
    const { getTeamIcons } = this.props;

    this.tableContainerRef = React.createRef();
    this.tableAndPreviewRef = React.createRef();
    this.dragContainerRef = React.createRef();
    this.dragRef = React.createRef();

    window.addEventListener('beforeunload', this.onBeforeUnload);
    document.addEventListener('mousedown', this.mouseDownHandler, false);
    document.addEventListener('mouseup', this.mouseUpHandler, false);
    document.addEventListener('mousemove', this.mouseMoveHandler, false);

    getTeamIcons();
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
    document.removeEventListener('mousedown', this.mouseDownHandler, false);
    document.removeEventListener('mouseup', this.mouseUpHandler, false);
    document.removeEventListener('mousemove', this.mouseMoveHandler, false);
  }

  componentDidUpdate(prevProps: IProps) {
    ReactTooltip.rebuild();
    const { product, resetSelectedAssets } = this.props;
    if (product !== prevProps.product) {
      resetSelectedAssets(true);
      this.handleSelectedAssets([], []);
    }
    if (!this.state.loadedInitialAsset) {
      const assetIdParam = 'assetId';
      const { updateRawAsset, loadedAssetMetadata } = this.props;
      const { location: { search } } = window;
      const params = new URLSearchParams(search);
      const assetId = params.get(assetIdParam);
      if (loadedAssetMetadata) {
        if (assetId) {
          (async () => {
            try {
              const assetDetails = await getAssetFromApi(assetId);
              if (assetDetails) updateRawAsset(assetDetails);
            } catch (e) {
              console.log(`Error loading asset details for assetId ${assetId} from URL parameter`, e);
            }
          })();
        }
        this.setState({
          loadedInitialAsset: true,
        });
      }
    }
  }

  publishToProfiles = async (
    selectedPublishProfiles: IPublishSettings<any>[],
    publishMetadata: IPublishMetadata = null,
    publishAssets: IPublishAsset[] = [],
  ) => {
    const { selectedAssetIds: selectedAssets } = this.state;
    const { publishSelectedAssetsToEndPoints, isUserVaultSuperAdmin } = this.props;
    const assets = publishAssets.length === 0
      ? selectedAssets.map((assetId) => ({ assetId, renditionType: PublishRenditionType.Full })) : publishAssets;
    await publishSelectedAssetsToEndPoints({
      publishSettings: selectedPublishProfiles,
      publishMetadata,
      assets,
    }, isUserVaultSuperAdmin);

    this.resetSelectedAssetsOnSuccess();
  };

  resetSelectedAssetsOnSuccess = () => {
    const { resetSelectedAssets, areAssetsPublished } = this.props;
    if (areAssetsPublished) {
      resetSelectedAssets(true);
      this.handleSelectedAssets([], []);
    }
  };

  // NOTE: asset preview panel function, to be iterated
  // The state is lifted from child component <SearchTable>
  // ↑ why? @Abi
  handleClickRow = async (index: number, event: React.MouseEvent<HTMLElement>) => {
    /* eslint-disable no-shadow */
    const { searchResponse, updateRawAsset } = this.props;

    if (isNumber(index)) {
      const assetId = searchResponse.hits.hits[index]._id;
      const assetDetails = await getAssetFromApi(assetId);
      updateRawAsset(assetDetails);
      window.history.pushState(this.state, '', `${Routes.HOME}?assetId=${assetId}`);
    }
  };

  updateDeleteStatus = () => {
    const { assetIdSelection } = this.state;
    this.handleSelectedAssets([], []);
    assetIdSelection.deselectAll();
  };

  onBulkUpdateCallback = () => {
    const { resetSelectedAssets, resetPreviewAssetDetails } = this.props;
    resetSelectedAssets(true);
    this.handleSelectedAssets([], []);
    resetPreviewAssetDetails();
  };

  handleSelectedAssets = (assetIds: string[], assets: AssetHit[]) => {
    this.setState({
      selectedAssetIds: assetIds,
      selectedAssets: assets,
    });
  };

  handleClearAdvancedFilter = async () => {
    const {
      clearAllFilterValues, onClearAllAdvancedFilters, queryGamesActionConnect,
    } = this.props;
    clearAllFilterValues();
    onClearAllAdvancedFilters();
    queryGamesActionConnect();
  };

  renderDialogToDeleteAssets = () => {
    const { clickDeleteButton } = this.props;
    const { selectedAssets } = this.state;
    clickDeleteButton(true, selectedAssets);
  };

  renderDialogToBulkUpdateAssets = () => {
    const { clickBulkEditButton } = this.props;
    const { selectedAssets } = this.state;
    clickBulkEditButton(true, selectedAssets);
  };

  handleOpenShareMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({
      shareAnchorEl: e.currentTarget,
    });
  };

  handleCloseShareMenu = () => {
    this.setState({
      shareAnchorEl: null,
    });
  };

  getAssetIds = () => {
    const { selectedAssetIds } = this.state;
    return [...selectedAssetIds];
  };

  getAssetTags = () => {
    const { selectedAssets } = this.state;
    return ([...selectedAssets].map((asset) => asset._source.orgTagIds));
  };

  getSharedAssetTags = () => {
    const assetTags = this.getAssetTags();
    if (assetTags !== null && assetTags.length > 0) {
      return (_.intersectionBy(...assetTags, '_id'));
    }
    return [];
  };

  getIndeterminateAssetTags = () => {
    const assetTags = this.getAssetTags();
    const flatAssetTags = assetTags.flat();
    const uniqAssetTags = _.uniqBy(flatAssetTags, '_id');
    const sharedAssetTags = this.getSharedAssetTags();
    if (uniqAssetTags !== null && uniqAssetTags.length > 0) {
      return (_.differenceBy(uniqAssetTags, sharedAssetTags, '_id'));
    }
    return [];
  };

  handleOwnedToggle = () => {
    const { assetIdSelection } = this.state;
    const {
      toggleOwned,
      queryGamesActionConnect,
    } = this.props;
    assetIdSelection.deselectAll();
    toggleOwned();
    queryGamesActionConnect();
  };

  handleNoSecurityProfilesToggle = () => {
    const { assetIdSelection } = this.state;
    const {
      toggleNoSecurityProfile,
      queryGamesActionConnect,
    } = this.props;
    assetIdSelection.deselectAll();
    toggleNoSecurityProfile();
    queryGamesActionConnect();
  };

  handleSecurityProfileFiltersChanged = (selectedSecurityProfiles: ISecurityProfileOption[]) => {
    const { assetIdSelection } = this.state;
    const {
      setAdvancedSecurityProfileFiltersChanged,
      queryGamesActionConnect,
    } = this.props;
    assetIdSelection.deselectAll();
    setAdvancedSecurityProfileFiltersChanged(selectedSecurityProfiles);
    queryGamesActionConnect();
  };

  onBulkDownload = async (isVaultSuperAdmin: boolean) => {
    const { selectedAssets } = this.state;
    selectedAssets.forEach(({ _id, _source }) => downloadAsset({
      _id,
      ..._source,
    }, isVaultSuperAdmin));
  };

  generateClearFiltersButton = () => {
    const {
      t, filters, isOwnedFilter, noSecurityProfilesFilter, selectedSecurityProfileOptions,
    } = this.props;

    const filterCount = Object.keys(filters).length;
    const advancedFilterCount = selectedSecurityProfileOptions.length + (isOwnedFilter ? 1 : 0) + (noSecurityProfilesFilter ? 1 : 0);
    return (
      <FilterButtonContainer>
        <VaultButton
          id={SearchResults.clearFilterId}
          variant="plainOnWhite"
          disabled={advancedFilterCount === 0 && filterCount === 0}
          onClick={this.handleClearAdvancedFilter}
        >
          {t(this.localeLookupKeys.clearFilter)}
        </VaultButton>
      </FilterButtonContainer>
    );
  };

  generateAdvancedFilterContainer = () => {
    const {
      isOwnedFilter, noSecurityProfilesFilter, securityProfileOptions,
      selectedSecurityProfileOptions, isUserVaultSuperAdmin,
    } = this.props;

    const advancedFilterCount = selectedSecurityProfileOptions.length + (isOwnedFilter ? 1 : 0) + (noSecurityProfilesFilter ? 1 : 0);
    return (
      <FilterContainer className="AdvanedFilter">
        <AdvancedFilterPopover
          filterCount={advancedFilterCount}
        >
          <AdvancedFilterButtonContainer>
            <FilterButtonContainer>
              <StyledControl
                label="Owned Assets"
                labelPlacement="start"
                control={(
                  <Switch
                    checked={isOwnedFilter}
                    onChange={(e) => this.handleOwnedToggle()}
                  />
                )}
              />
            </FilterButtonContainer>
            {isUserVaultSuperAdmin && (
              <FilterButtonContainer>
                <StyledControl
                  label="Non Assigned Assets"
                  labelPlacement="start"
                  control={(
                    <Switch
                      checked={noSecurityProfilesFilter}
                      onChange={(e) => this.handleNoSecurityProfilesToggle()}
                    />
                  )}
                />
              </FilterButtonContainer>
            )}
          </AdvancedFilterButtonContainer>
          {isUserVaultSuperAdmin && (
            <SecurityProfileFilterContainer>
              <SecurityProfileFilter
                securityProfiles={securityProfileOptions}
                selectedSecurityProfileOptions={selectedSecurityProfileOptions}
                onSecurityProfileFiltersChanged={this.handleSecurityProfileFiltersChanged}
              />
            </SecurityProfileFilterContainer>
          )}
        </AdvancedFilterPopover>
      </FilterContainer>
    );
  };

  render() {
    const {
      searchResponse,
      userOrgsSecurityProfiles,
      toggleShareDialogConnect,
      toggleEmailDialogConnect,
      isPublishPermitted,
      isAssetDeletionPermitted,
      isAssetDownloadPermitted,
      isAssetBulkEditPermitted,
      isAssetBulkTagPermitted,
      isSharePermitted,
      isDeleteButtonClicked,
      isBulkEditButtonClicked,
      isUserVaultSuperAdmin,
      isUserExchangeAdmin,
      isUserVaultCustomerAdmin,
      isUserVaultEditor,
      product,
      isExchange,
      onExchangeUploadOpen,
      publishSettings,
      onVaultUploadOpen,
      isVault,
      isMyVault,
    } = this.props;

    const {
      selectedAssets,
      selectedAssetIds,
      assetIdSelection,
      shareAnchorEl,
      addTagsAnchorEl,
    } = this.state;

    const bulkTagIcon: JSX.Element = (
      <TagIcon />
    );

    const searchTableProps = {
      assetIdSelection,
      rows: searchResponse ? searchResponse.hits.hits : [],
      handleClickRow: this.handleClickRow,
      handleSelectedAssets: this.handleSelectedAssets,
      selectedAssets,
      selectedAssetIds,
    };

    const deleteAssetsDialogProps = {
      updateSelectedAssets: this.updateDeleteStatus,
    };

    const bulkEditDialogProps = {
      onBulkUpdateCallback: this.onBulkUpdateCallback,
    };

    const dragContainerProps = {
      $isDragging: this.isPreviewPanelDragging,
    };

    const ownedAssets = isUserVaultSuperAdmin
      ? selectedAssets
      : selectedAssets.filter((asset) => userOrgsSecurityProfiles.indexOf(asset._source.owner) !== -1); // TODO

    const assetTitles = ownedAssets
      .map((asset) => asset._source.title)
      .toString()
      .replace(/(.{75})..+/, '$1...');

    // Bulk buttons enabled flags
    const isSocialShareEnabled = (selectedAssets.length > 0);
    const isVaultShareEnabled = (selectedAssets.length > 0);
    const isShareOptionsEnabled = (ownedAssets.length > 0 && ownedAssets.length === selectedAssets.length);
    const isDeleteEnabled = (ownedAssets.length > 0 && ownedAssets.length === selectedAssets.length);
    const isBulkDownloadEnabled = selectedAssets.length > 1;
    const isBulkEditEnabled = (ownedAssets.length > 0 && ownedAssets.length === selectedAssets.length && selectedAssets.length > 1);
    const isBulkTagEnabled = (ownedAssets.length > 0 && ownedAssets.length === selectedAssets.length && selectedAssets.length > 1);

    const hasTwitterConfigured = (publishSettings
      && publishSettings.find((s) => s.type === SettingType.Twitter && s.state === SettingState.Active));
    const hasYoutubeConfigured = (publishSettings
      && publishSettings.find((s) => s.type === SettingType.YouTube && s.state === SettingState.Active));
    const hasVaultEndpointConfigured = (publishSettings
      && publishSettings.find((s) => (s.type === SettingType.LAN || s.type === SettingType.Yahoo)
        && (s.state === SettingState.Active)));

    const bulkTagMenuProps = {
      onBulkTagCallback: this.onBulkUpdateCallback,
      addTagsAnchorEl,
      indeterminateTags: this.getIndeterminateAssetTags(),
      bulkTags: [...selectedAssets],
      assetTags: this.getSharedAssetTags(),
      assetId: this.getAssetIds(),
      addTagButton: AddTagButton,
      buttonDisabled: !isBulkTagEnabled,
      buttonIcon: bulkTagIcon,
    };

    return (
      <QueryResultContainer id="Query.Result.Container">
        {!!product && (
          <ShareDialog />
        )}
        <ShareEmailDialog />
        <TableAndPreviewContainer
          ref={this.tableAndPreviewRef}
          id="Table.And.Preview.Container"
          onClick={(e) => /* eslint-disable-line no-return-assign */ this.isPreviewPanelDragging = false}
        >
          <TableContainer ref={this.tableContainerRef} id="Table.Container">
            <ResultDetailsContainer id="Result.Details.Container">
              {isExchange && isAssetDeletionPermitted && (
                <>
                  <UploadExchangeDialog />
                  <VaultButton
                    data-auto="ExchUploadBtn"
                    variant="primaryOnWhite"
                    onClick={onExchangeUploadOpen}
                  >
                    <CloudUploadIcon
                      data-tip="Upload Exchange File"
                      data-for="results-actions-tooltip"
                    />
                  </VaultButton>
                </>
              )}
              {isVault
                && (isUserVaultSuperAdmin || isUserVaultCustomerAdmin || isUserVaultEditor || isUserExchangeAdmin)
                && (
                  <>
                    <VaultUploadDialog />
                    <VaultButton
                      variant="primaryOnWhite"
                      onClick={onVaultUploadOpen}
                      data-auto="VaultUploadBtn"
                    >
                      <CloudUploadIcon
                        data-tip="Upload Vault File"
                        data-for="results-actions-tooltip"
                      />
                    </VaultButton>
                  </>
                )}
              {!isExchange && !isVault && isAssetDeletionPermitted && (
                <DropContainer>
                  <Dropzone onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <VaultButton
                            variant="primaryOnWhite"
                            data-auto="MyVaultUploadBtn"
                          >
                            <CloudUploadIcon
                              data-tip="Upload to My Vault"
                              data-for="results-actions-tooltip"
                            />
                          </VaultButton>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </DropContainer>
              )}
              <ResultsActionContainer>
                {
                  (isPublishPermitted && !isUserExchangeAdmin) && (
                    <>
                      {hasTwitterConfigured && (
                        <>
                          <SocialPublishOptions
                            data-auto="ShareTwitter"
                            socialButton={SocialButton}
                            disabled={!isSocialShareEnabled}
                            socialType={SettingType.Twitter}
                          />
                          {(hasYoutubeConfigured || hasVaultEndpointConfigured) && (
                            <ButtonSpacer />
                          )}
                        </>
                      )}

                      {hasYoutubeConfigured && (
                        <>
                          <SocialPublishOptions
                            socialButton={SocialButton}
                            disabled={!isSocialShareEnabled}
                            socialType={SettingType.YouTube}
                          />
                          {hasVaultEndpointConfigured && (
                            <ButtonSpacer />
                          )}
                        </>
                      )}

                      <TwitterPublishDialog onPublish={this.publishToProfiles} />
                      <YouTubePublishDialog onPublish={this.publishToProfiles} />
                      {hasVaultEndpointConfigured && (
                        <VaultPublishOptions
                          disabled={!isVaultShareEnabled}
                          onPublish={this.publishToProfiles}
                          selectedAssets={selectedAssets}
                        />
                      )}

                      {(hasYoutubeConfigured || hasTwitterConfigured || hasVaultEndpointConfigured) && (
                        <Separator horizontal={false} color={Colors.BLACK_30} />
                      )}
                    </>
                  )
                }
                {
                  (isUserVaultSuperAdmin || isUserExchangeAdmin || isSharePermitted) && (
                    <>
                      <Menu
                        anchorEl={shareAnchorEl}
                        open={Boolean(shareAnchorEl)}
                        onClose={this.handleCloseShareMenu}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            toggleShareDialogConnect(ownedAssets);
                            this.handleCloseShareMenu();
                          }}
                          data-auto="ShareToVault"
                        >
                          Share to Vault
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            toggleEmailDialogConnect(ownedAssets);
                            this.handleCloseShareMenu();
                          }}
                          data-auto="SendEmailLink"
                        >
                          Send Email Link
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            copyAssetsToClipboard(ownedAssets);
                            this.handleCloseShareMenu();
                          }}
                        >
                          Copy Link to Clipboard
                        </MenuItem>
                      </Menu>
                      <VaultButton
                        onClick={this.handleOpenShareMenu}
                        variant="primaryOnWhite"
                        data-auto="ShareBtn"
                        data-tip={`Share ${ownedAssets.length} assets(s): ${assetTitles}`}
                        data-for="results-actions-tooltip"
                        disabled={!isShareOptionsEnabled}
                      >
                        <ShareIcon />
                      </VaultButton>
                      <Separator horizontal={false} color={Colors.BLACK_30} />
                    </>
                  )
                }
                {
                  isAssetDeletionPermitted && (
                    <VaultButton
                      id={SearchResults.deleteButtonId}
                      variant="primaryOnWhite"
                      data-auto="DeleteBtn"
                      disabled={!isDeleteEnabled}
                      onClick={this.renderDialogToDeleteAssets}
                    >
                      <Delete />
                    </VaultButton>
                  )
                }
                {
                  ((isPublishPermitted || isAssetDownloadPermitted) && (isVault || isMyVault)) && (
                    <>
                      <Separator horizontal={false} color={Colors.BLACK_30} />
                      <VaultButton
                        id={SearchResults.bulkDownloadButtonId}
                        variant="primaryOnWhite"
                        data-auto="BulkDownloadBtn"
                        disabled={!isBulkDownloadEnabled}
                        onClick={() => this.onBulkDownload(isUserVaultSuperAdmin)}
                        style={{ height: '42px' }}
                      >
                        Bulk Download
                      </VaultButton>
                    </>
                  )
                }
                {
                  isAssetBulkEditPermitted && (
                    <>
                      <Separator horizontal={false} color={Colors.BLACK_30} />
                      <VaultButton
                        id={SearchResults.bulkUpdateButtonId}
                        variant="primaryOnWhite"
                        data-auto="BulkEditBtn"
                        disabled={!isBulkEditEnabled}
                        onClick={this.renderDialogToBulkUpdateAssets}
                        style={{ height: '42px' }}
                      >
                        Bulk Edit
                      </VaultButton>
                    </>
                  )
                }
                {
                  ((isAssetBulkTagPermitted && isVault) && (
                    <>
                      <Separator horizontal={false} color={Colors.BLACK_30} />
                      <AddTagsMenu
                        {...bulkTagMenuProps}
                      />
                    </>
                  ))
                }
              </ResultsActionContainer>
              {this.generateClearFiltersButton()}
              {this.generateAdvancedFilterContainer()}
              <ReactTooltip
                id="results-actions-tooltip"
                delayShow={250}
                effect="solid"
              />
            </ResultDetailsContainer>
            <SearchTable {...searchTableProps} />
            <SearchPagination />
          </TableContainer>

          <AssetDetailsDragContainer ref={this.dragContainerRef} {...dragContainerProps}>
            <AssetDetailsDrag ref={this.dragRef} />
          </AssetDetailsDragContainer>

          <AssetDetails selectedAssetsCount={selectedAssets.length} />

        </TableAndPreviewContainer>
        {isDeleteButtonClicked
          && (<DeleteAssetsDialog {...deleteAssetsDialogProps} />)}
        {isBulkEditButtonClicked
          && (<BulkEditDialog {...bulkEditDialogProps} />)}
      </QueryResultContainer>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => {
  // VA-1660: ensure vaultEditor permissions only available to exchangeVendors with MyVault product
  const isMyVault = state.product.target === Product.MyVault;
  const isUserExchangeVendor = selectIsUserExchangeVendor(state);
  let isPublishPermitted = selectIsPublishPermitted(state);
  let isAssetDeletionPermitted = selectIsAssetDeletionPermitted(state);
  if (isUserExchangeVendor && !isMyVault) {
    isPublishPermitted = false;
    isAssetDeletionPermitted = false;
  }
  return {
    searchResponse: state.search.searchResponse,
    queryParams: state.search.queryParams,
    areAssetsPublished: state.publishSelectedAssetsToEndPoints.areAssetsPublished,
    filters: state.filterAssets.filters,
    isDeleteButtonClicked: state.deleteAssets.isDeleteButtonClicked,
    isBulkEditButtonClicked: state.bulkEditAssetsDialog.isBulkEditButtonClicked,
    isPublishPermitted,
    isAssetDeletionPermitted,
    isAssetDownloadPermitted: selectIsAssetDownloadPermitted(state),
    isAssetBulkEditPermitted: selectIsAssetBulkEditPermitted(state),
    isAssetBulkTagPermitted: selectIsAssetBulkTagPermitted(state),
    isSharePermitted: selectIsSharePermitted(state),
    isUserVaultSuperAdmin: selectIsUserVaultSuperAdmin(state),
    isUserExchangeAdmin: selectIsUserExchangeAdmin(state),
    isUserVaultCustomerAdmin: selectIsUserVaultCustomerAdmin(state),
    isUserVaultEditor: selectIsUserVaultEditor(state),
    userOrgsSecurityProfiles: selectUserOrgsSecurityProfilesIds(state),
    userOrgs: selectUserOrgIds(state),
    isOwnedFilter: state.search.isOwnedFilter,
    noSecurityProfilesFilter: state.search.noSecurityProfilesFilter,
    product: state.product.target,
    isMyVault,
    isVault: state.product.target === Product.Vault,
    isExchange: state.product.target === Product.Exchange,
    jobsOpen: state.jobStatus.isOpen,
    publishSettings: selectUserPublishSettings(state),
    teamIcons: state.search.teamIcons,
    systemSettings: state.systemSettings.systemSettings,
    iptcCategoryOptions: selectOptionsByName(LookupName.iptcCategory, state),
    securityProfileOptions: selectSecurityProfileOptions(state),
    selectedSecurityProfileOptions: selectSelectedSecurityProfileOptions(state),
    loadedAssetMetadata: loadedAssetMetadata(state),
  };
};

const mapDispatchToProps: IDispatchProps = {
  updateRawAsset: updateRawAssetDetails,
  publishSelectedAssetsToEndPoints,
  resetSelectedAssets: resetPublishedAssets,
  clearAllFilterValues: clearAllFilters,
  queryGamesActionConnect: queryGamesAction,
  resetPageConnect: resetPage,
  updateFilters: updateFilterValues,
  clickDeleteButton: toggleDeleteAssets,
  clickBulkEditButton: toggleBulkEditAssets,
  toggleShareDialogConnect: toggleShareDialog,
  toggleEmailDialogConnect: toggleEmailDialog,
  toggleOwned: toggleOwnedFilter,
  toggleNoSecurityProfile: toggleNoSecurityProfileFilter,
  onJobsOpen: openJobStatusReview,
  onJobsClose: closeJobStatusReview,
  onJobsExit: clearJobs,
  onExchangeUploadOpen: toggleUploadExchangeDialog,
  onVaultUploadOpen: toggleVaultUploadDialog,
  resetPreviewAssetDetails: resetAssetDetails,
  getTeamIcons: getTeamIconsAction,
  setAdvancedSecurityProfileFiltersChanged: onAdvancedSecurityProfileFiltersChanged,
  onClearAllAdvancedFilters: clearAllAdvancedFilters,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SearchResults));
